import { MapContainer, TileLayer, Marker, Popup } from "react-leaflet";
import L from "leaflet";
import "leaflet/dist/leaflet.css";

const ACCENT = "#c9944a";

const pinIcon = (color = ACCENT) =>
  L.divIcon({
    className: "borgo-pin",
    html: `<span style="display:block;width:14px;height:14px;background:${color};border:2px solid #121110;border-radius:50%;box-shadow:0 0 0 2px ${color}55;"></span>`,
    iconSize: [14, 14],
    iconAnchor: [7, 7],
  });

const points = [
  {
    name: "Borgo DiVino · Centro Storico di Marino",
    desc: "La casa vacanze, nel cuore del borgo antico",
    coords: [41.7703, 12.6586],
    main: true,
  },
  {
    name: "Stazione di Marino Laziale",
    desc: "Treno diretto per Roma Termini in 30 minuti",
    coords: [41.7626, 12.6507],
  },
  {
    name: "Lago di Castel Gandolfo",
    desc: "5 minuti di treno o 10 in auto/Cotral",
    coords: [41.7469, 12.6703],
  },
  {
    name: "Lago di Nemi",
    desc: "Circa 20 minuti in auto, famoso per le fragoline",
    coords: [41.7127, 12.7065],
  },
];

export default function MappaCastelli() {
  return (
    <div className="mt-16 border border-[#2a2825] bg-[#121110]" data-testid="mappa-castelli">
      <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-2 px-6 py-4 border-b border-[#2a2825]">
        <p className="font-mono-tag text-xs uppercase tracking-widest text-[#c9944a]">Mappa dei Castelli Romani</p>
        <p className="text-xs text-[#9e968b]">Marino · stazione del treno · laghi di Castel Gandolfo e Nemi</p>
      </div>
      <MapContainer
        center={[41.742, 12.672]}
        zoom={12}
        scrollWheelZoom={false}
        className="h-[320px] md:h-[420px] w-full z-0"
        data-testid="mappa-castelli-canvas"
      >
        <TileLayer
          attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a>'
          url="https://tile.openstreetmap.org/{z}/{x}/{y}.png"
        />
        {points.map((p) => (
          <Marker key={p.name} position={p.coords} icon={pinIcon(p.main ? ACCENT : "#9e968b")}>
            <Popup>
              <strong>{p.name}</strong>
              <br />
              {p.desc}
            </Popup>
          </Marker>
        ))}
      </MapContainer>
    </div>
  );
}
